export const DELETE_PARAM = 'DELETE_PARAM';
export const DELETE_PARAM_SUCCESS = 'DELETE_PARAM_SUCCESS';
export const DELETE_PARAM_ERROR = 'DELETE_PARAM_ERROR';
